import * as React from 'react';
import { useInView } from 'react-intersection-observer';
import { MediaQuery } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { ActionButtons } from '../components/ActionButtons.js';

const ActionButtonsContainer = ({ links  })=>{
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            toCart: getLabel('cart.actions.goToCart'),
            toCheckout: getLabel('cart.actions.goToCheckout')
        })
    , [
        getLabel
    ]);
    const [buttonsRef, buttonsInview] = useInView();
    const showStickyButtons = isSmallScreen && !buttonsInview;
    return /*#__PURE__*/ React.createElement(ActionButtons, {
        buttonsRef: buttonsRef,
        isSmallScreen: isSmallScreen,
        labels: labels,
        links: links,
        showStickyButtons: showStickyButtons
    });
};

export { ActionButtonsContainer };
//# sourceMappingURL=ActionButtonsContainer.js.map
